const apiConfig = {
  timeout: 1 * 60 * 1000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
};

export default apiConfig;
